module.exports = __webpack_public_path__ + "static/media/playline-logo1.30d3434f.svg";